export class LineScaleMode {
    public static HORIZONTAL: string = "horizontal";
    public static NONE: string = "none";
    public static NORMAL: string = "normal";
    public static VERTICAL: string = "vertical";
}
